<template>
  <CockpitDialog
    title="报警消息中心"
    @close="closeAlarmList"
    :top="'200px'"
    :left="'400px'"
    :width="'1000px'"
    :height="'600px'"
  >
    <div class="w-full h-full relative">
      <div class="flex mb-20px mr-10px">
        <el-select
          v-model="searchForm.alarmSourceId"
          size="small"
          class="mr-10px !w-50"
          placeholder="报警来源"
          clearable
          filterable
          popper-class="visualization-select-popper"
        >
          <el-option
            v-for="item in allSourceList"
            :key="item.id"
            :value="item.id"
            :label="item.alarmSource"
          ></el-option>
        </el-select>
        <el-date-picker
          class="mr-10px w-300px"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
          v-model="searchForm.searchTime"
          popper-class="visualization-picker-popper"
          clearable
        ></el-date-picker>
        <el-button size="small" type="primary" @click="handleSearch">查询</el-button>
        <el-button size="small" type="primary" @click="reset">重置</el-button>
        <el-button size="small" type="primary" @click="settingVisible = true">设置</el-button>
      </div>
      <el-table
        :data="alarmList"
        border
        class="w-full"
        height="calc(100% - 110px)"
        v-loading="alarmLoading"
      >
        <el-table-column label="序号" type="index" width="50"></el-table-column>
        <el-table-column
          label="报警描述"
          prop="alarmDescribe"
          min-width="175px"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="报警来源"
          prop="alarmSourceName"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="触发报警时间" min-width="125px" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <span>{{
              row.alarmTime ? dayjs(row.alarmTime).format('YYYY-MM-DD HH:mm:ss') : row.alarmTime
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100px">
          <template slot-scope="{ row }">
            <span @click="jumpClick(row)" class="text-hex-00BCC8 cursor-pointer">跳转</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @current-change="getAlarmList"
        :current-page.sync="page.pageNo"
        :page-size="page.pageSize"
        layout="prev, pager, next"
        :total="page.total"
        class="flex justify-center mt-20px ml-10px"
      ></el-pagination>
    </div>
    <CockpitDialog
      v-if="settingVisible"
      title="设置接收报警通知"
      @close="settingVisible = false"
      :top="'300px'"
      :left="'625px'"
      :width="'550px'"
      :height="'500px'"
    >
      <div class="flex mb-20px mr-10px">
        <el-button size="small" type="primary" @click="operateSource(true)">全部开启</el-button>
        <el-button size="small" type="primary" @click="operateSource(false)">全部关闭</el-button>
      </div>
      <el-table
        :data="alarmSourceList"
        border
        class="w-full"
        height="calc(100% - 110px)"
        v-loading="sourceLoading"
      >
        <el-table-column label="序号" type="index" width="50"></el-table-column>
        <el-table-column
          label="报警来源"
          prop="alarmSource"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="是否开启" width="100px">
          <template slot-scope="{ row }">
            <el-switch @change="operateSource($event, row)" v-model="row.isOpen"></el-switch>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @current-change="getSourceList"
        :current-page.sync="settingPage.pageNo"
        :page-size="settingPage.pageSize"
        layout="prev, pager, next"
        :total="settingPage.total"
        class="flex justify-center mt-20px ml-10px"
      ></el-pagination>
    </CockpitDialog>
  </CockpitDialog>
</template>

<script>
import dayjs from 'dayjs'
import { isNil, get, find, isEmpty, omit, head, map } from 'lodash'
import {
  ThreeDimensionalAlarmCenterApi,
  AlarmSourceConfigurationTableApi,
  SectionApi,
  SchemeApi,
} from '@wiz-api/cloud-render-management'

const alarmCenterApi = new ThreeDimensionalAlarmCenterApi()
const alarmSourceConfig = new AlarmSourceConfigurationTableApi()
const schemeApi = new SchemeApi()
const sectionApi = new SectionApi()

const CockpitDialog = () => {
  return import('@/components/cockpit/CockpitDialog')
}
export default {
  components: {
    CockpitDialog,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      searchForm: {
        alarmSourceId: '',
        searchTime: '',
      },
      alarmList: [], // 报警列表
      alarmLoading: false,
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      settingPage: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      allSourceList: [], // 所有的报警配置来源，用于下拉框选择
      // 报警配置来源数据，表格展示
      alarmSourceList: [], // 报警来源列表
      settingVisible: false,
      sourceLoading: false,
      currentScheme: '', // 当前打开的方案
      allSection: '', // 当前方案下的所有版块
    }
  },
  async created() {
    this.searchForm.searchTime = [
      dayjs()
        .startOf('date')
        .format('YYYY-MM-DD HH:mm:ss'),
      dayjs()
        .endOf('date')
        .format('YYYY-MM-DD HH:mm:ss'),
    ]
    await this.getAlarmList()
    this.getAllSource()
    this.getSourceList()
    this.currentScheme = await this.getCurrentScheme()
    this.allSection = await this.getSection(this.currentScheme)
  },
  methods: {
    // 获取报警列表
    async getAlarmList() {
      this.alarmLoading = true
      const [err, res] = await alarmCenterApi.getThreeDimensionalAlarmList({
        alarmSourceId: this.searchForm.alarmSourceId,
        startTime: this.searchForm.searchTime ? this.searchForm.searchTime[0] : null,
        endTime: this.searchForm.searchTime ? this.searchForm.searchTime[1] : null,
        maxResultCount: this.page.pageSize,
        skipCount: (this.page.pageNo - 1) * this.page.pageSize,
      })
      if (!err && !isNil(res)) {
        this.alarmList = res.items
        this.page.total = res.totalCount
      }
      this.alarmLoading = false
    },
    // 获取报警来源下拉框数据
    async getAllSource() {
      const [errSelect, resSelect] = await alarmSourceConfig.getAlarmSourceConfigurationList({
        maxResultCount: 1000,
        skipCount: 0,
      })
      if (!errSelect && resSelect) {
        this.allSourceList = resSelect.items
      }
    },
    // 获取报警来源列表
    async getSourceList() {
      this.sourceLoading = true
      // 获取报警来源表格数据
      const [err, res] = await alarmSourceConfig.getAlarmSourceConfigurationList({
        maxResultCount: this.settingPage.pageSize,
        skipCount: (this.settingPage.pageNo - 1) * this.settingPage.pageSize,
      })
      if (!err && res) {
        this.alarmSourceList = res.items
        this.settingPage.total = res.totalCount
      }
      this.sourceLoading = false
    },
    // 搜索
    async handleSearch() {
      this.page.pageNo = 1
      await this.getAlarmList()
    },
    // 重置搜索表单
    reset() {
      this.searchForm = this.$options.data().searchForm
      this.searchForm.searchTime = [
        dayjs()
          .startOf('date')
          .format('YYYY-MM-DD HH:mm:ss'),
        dayjs()
          .endOf('date')
          .format('YYYY-MM-DD HH:mm:ss'),
      ]
      this.handleSearch()
    },
    // 获取当前方案
    async getCurrentScheme() {
      const keyword = get(this.$route, 'query.programmeCode')
      // 未匹配当前用户设置方案，使用默认方案
      const params = omit(
        {
          keyword,
          isEnable: true,
          maxResultCount: 1,
          skipCount: 0,
        },
        keyword ? 'isEnable' : 'name'
      )
      const [err, res] = await schemeApi.getList(params)
      if (!err && res && res.items) {
        return get(head(res.items), 'id')
      }
    },
    // 获取当前方案所有的板块
    async getSection(schemeId) {
      const [err, res] = await sectionApi.getList({ schemeId })
      if (!err && res && res.items) {
        return res.items
      }
    },
    // 点击报警跳转至消息中心
    async jumpClick(data) {
      this.$emit('openPersonAlarmList')
      this.closeAlarmList()
      if (!isNil(data.alarmSourceName)) {
        const source = find(this.allSourceList, ['alarmSource', data.alarmSourceName])
        if (!isEmpty(source)) {
          // 跳转至后台
          if (source.jumpMethod === 0) {
            if (!isEmpty(source.jumpLink)) {
              this.$router.push(source.jumpLink)
            } else {
              return this.$message.warning({
                showClose: true,
                $message: '报警来源未配置跳转路由，无法跳转，请重新配置',
              })
            }
          } else {
            // 跳转至配置三维板块
            // 判断跳转方案是否是当前的打开的方案
            if (this.currentScheme !== source.schemeSelection) {
              return this.$message.warning({
                showClose: true,
                message: '报警来源配置非当前方案，无法跳转，请重新配置',
              })
            }
            // 判断跳转板块是否存在
            const section = find(this.allSection, ['id', source.blockSelection])
            if (isEmpty(section)) {
              return this.$message.warning({
                showClose: true,
                message: '报警来源配置板块不存在，无法跳转，请重新配置',
              })
            }
            const allFunction = get(section, 'extraDto.businessFunctionInfoDtos')
            const currentFunction = find(allFunction, ['id', source.moduleSelection])
            // 判断跳转模块是否存在
            if (isEmpty(currentFunction)) {
              return this.$message.warning({
                showClose: true,
                message: '报警来源配置模板不存在，无法跳转，请重新配置',
              })
            }
            if (currentFunction.functionLocationType !== 0) {
              this.$emit('alarmJump', section, currentFunction.code)
            }
          }
        } else {
          this.$message.warning({
            showClose: true,
            message: '该报警来源未配置，无法跳转',
          })
        }
      }
    },
    // 设置开启或者关闭报警
    async operateSource(isOpen, data) {
      // 批量操作
      if (isNil(data)) {
        this.$confirm(`是否${isOpen ? '开启' : '关闭'}全部报警通知`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(async () => {
          const [err, res] = await alarmSourceConfig.updateAllEntityDataIsOpen({ isopen: isOpen })
          if (!err) {
            this.$message.success({
              showClose: true,
              message: `${isOpen ? '开启' : '关闭'}成功`,
            })
            this.getSourceList()
          }
        })
      } else {
        // 单个操作
        const [err, res] = await alarmSourceConfig.update(data.id, {
          body: {
            ...data,
            isOpen,
          },
        })
        if (!err) {
          this.$message.success({
            showClose: true,
            message: `${isOpen ? '开启' : '关闭'}成功`,
          })
          this.getSourceList()
        }
      }
    },
    closeAlarmList() {
      this.$emit('update:visible', false)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/styles/table.scss';

::v-deep .el-loading-mask {
  background: linear-gradient(180deg, rgb(8 34 57 / 90%) 0%, rgba(3, 25, 43, 0.9) 93.96%);
}
</style>
